<div
  [class]="'container ' + getAppearanceClassName()"
  [class.checked]="item.checked"
  (click)="handleClick()"
>
  <div
    *ngIf="item.color"
    class="color"
    [style.backgroundColor]="item.color"
  ></div>
  <div
    [class]="'label prevent-select ' + getAppearanceClassName()"
    prlwResponsive
  >
    {{ item.label }}
  </div>
  <svg
    *ngIf="showArrow"
    class="arrow"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 8L0.669873 0.5L9.33013 0.500001L5 8Z" fill="black" />
  </svg>
</div>
